import type { ReactElement } from 'react'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { DetailsValue } from '@/buyer-portal/components/features/shared'
import { HeaderAlignedPageWidth } from '@/components/PageWidth'
import type { CmsSellerProfile } from '@/helpers/api/fetchPayload'
import { signUpCtaLocationForTab } from '@/helpers/telemetry/signupLinkTracking'

import { lexicalHasContent } from './cmsSellerProfileAbout'
import CostcoAboutDetails from './cstAboutDetails'
import { SellerProfileLexicalRichText } from './SellerProfileLexicalRichText'
import { Container, InfoSection, StorefrontTableContainer, Title } from './ui'

/** Hand-built About bodies by storefront slug; a slug with no entry falls through to the CMS. */
const LEGACY_ABOUT_BY_SLUG: Record<string, () => ReactElement> = {
  costco: CostcoAboutDetails,
}

type AboutContentProps = {
  cmsSellerProfile?: CmsSellerProfile | null
  /** True when ENABLE_ABOUT_FAQ_BY_STOREFRONT_ID includes this storefront (legacy Costco UI). */
  legacyCostcoStyleAboutEnabled: boolean
  sellerSlug: string
}

export default function AboutContent({
  cmsSellerProfile,
  legacyCostcoStyleAboutEnabled,
  sellerSlug,
}: AboutContentProps) {
  const cms = cmsSellerProfile
  const LegacyAbout = legacyCostcoStyleAboutEnabled
    ? LEGACY_ABOUT_BY_SLUG[sellerSlug.toLowerCase()]
    : undefined
  // The tab is the About Tab Content field alone; `aboutSections` belong to the sign-in accordion.
  const showCmsRich = Boolean(cms && lexicalHasContent(cms.aboutIntro))
  const signUpCtaLocation = cms
    ? signUpCtaLocationForTab(cms.sellerSlug, 'about')
    : undefined

  return (
    <HeaderAlignedPageWidth>
      <StorefrontTableContainer>
        <Title>
          <FormattedMessage id="Storefront.about.title" />
        </Title>
        <InfoSection>
          <DetailsValue>
            {/* A hand-built body wins over the CMS when the LD allowlist names this storefront. */}
            {LegacyAbout ? (
              <LegacyAbout />
            ) : showCmsRich && cms ? (
              <Container>
                <SellerProfileLexicalRichText
                  data={cms.aboutIntro}
                  signUpCtaLocation={signUpCtaLocation}
                />
              </Container>
            ) : (
              <Container>
                <p>
                  <FormattedMessage id="Storefront.about.emptyCms" />
                </p>
              </Container>
            )}
          </DetailsValue>
        </InfoSection>
      </StorefrontTableContainer>
    </HeaderAlignedPageWidth>
  )
}
